import styled from "@emotion/styled";

import { fontRobotoCondensed, fontSourceSerif4, theme } from "shared/lib/styles";

import { EntityLink } from "scmp-app/components/entity-link";
import { EntityOnelineMenu } from "scmp-app/components/entity-oneline-menu";
import { MenuItem } from "scmp-app/components/entity-oneline-menu/styles";

export const Container = styled.div`
  inline-size: 100%;
  padding-block-start: 12px;
  border-block-start: 1px #000000 solid;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  ${theme.breakpoints.up("tablet")} {
    flex-direction: row;
    gap: 24px;
    align-items: center;
  }
`;

export const TitleLink = styled(EntityLink)`
  flex-shrink: 0;

  padding-block-end: 10px;

  color: #000000;
  font-weight: 400;
  font-size: 28px;
  font-family: ${fontSourceSerif4};
  line-height: 90%;
  letter-spacing: -1.4px;
  white-space: nowrap;
`;

export const KeyIndustries = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;

  min-inline-size: 0;
`;

export const KeyIndustriesLabel = styled.span`
  flex-shrink: 0;

  color: #333333;
  font-weight: 400;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  font-style: italic;
  white-space: nowrap;
`;

export const StyledEntityOnelineMenu = styled(EntityOnelineMenu)`
  min-inline-size: 0;

  ${MenuItem} {
    font-family: ${fontRobotoCondensed};
  }
`;
